import e from "@dialpad/dialtone-tokens/layered/themes/tokens-plum-colors.css?inline";
//#region themes/plum.js
var t = {
	brand: {
		css: e,
		name: "plum"
	},
	material: { name: "steel" }
};
//#endregion
export { t as default };
